// src/store/modules/city.js
import { App } from '@/api/app';

const state = {
  // 城市列表首字母索引
  cityListFirst: [],
  // 城市列表数据
  cityList: [],
  // 最后更新时间戳
  lastUpdated: 0,
  // 数据加载状态
  loading: false
};

const mutations = {
  // 设置城市数据
  SET_CITY_DATA(state, { firstList, dataList }) {
    state.cityListFirst = firstList;
    state.cityList = dataList;
    state.lastUpdated = Date.now();
  },

  // 清除城市数据
  CLEAR_CITY_DATA(state) {
    state.cityListFirst = [];
    state.cityList = [];
    state.lastUpdated = 0;
  },

  // 设置加载状态
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};

const actions = {
  // 获取城市数据
  async fetchCityData({ state, commit }, expiry = 7 * 24 * 60 * 60 * 1000) {
    // 如果数据未过期，直接返回 true 表示使用缓存
    if (state.lastUpdated !== 0 && Date.now() - state.lastUpdated <= expiry && state.cityListFirst.length > 0) {
      return true;
    }

    try {
      commit('SET_LOADING', true);
      const res = await App.queryCom();
      if (res.errcode == 0) {
        // 处理城市数据
        const processedData = processCityData(res.data);
        commit('SET_CITY_DATA', {
          firstList: processedData.sortedKeys,
          dataList: processedData.groupedData
        });
        return true;
      }
      return false;
    } catch (error) {
      console.error('加载城市数据失败:', error);
      return false;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

// 处理城市数据，按首字母分组
const processCityData = (cityData) => {
  const groups = {};
  const pinyinPro = require('pinyin-pro');

  cityData.forEach(province => {
    province.children.forEach(city => {
      if (city.name) {
        // 获取城市名首字母
        const pinyinResult = pinyinPro.pinyin(city.name, {
          pattern: 'first',//拼音的首字母
          toneType: 'none',// 获取不带声调的拼音
          type: 'array'//数组形式
        });
        const firstLetter = pinyinResult[0].toUpperCase() || '#';
        // 确保是有效字母
        if (!/^[A-Z]$/.test(firstLetter)) {
          if (!groups['#']) groups['#'] = [];
          groups['#'].push(city);
        } else {
          if (!groups[firstLetter]) groups[firstLetter] = [];
          groups[firstLetter].push(city);
        }
      }
    });
  });

  // 按字母顺序排序
  const sortedKeys = Object.keys(groups).sort((a, b) => {
    // 特殊字符排在最后
    if (a === '#') return 1;
    if (b === '#') return -1;
    return a.localeCompare(b);
  });

  const groupedData = sortedKeys.map(key => groups[key]);
  
  return { sortedKeys, groupedData };
};

const getters = {
  cityListFirst: state => state.cityListFirst,
  cityList: state => state.cityList,
  lastUpdated: state => state.lastUpdated,
  loading: state => state.loading,
  isExpired: (state) => (expiry = 7 * 24 * 60 * 60 * 1000) => {
    if (state.lastUpdated === 0) return true;
    return Date.now() - state.lastUpdated > expiry;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};


// WEBPACK FOOTER //
// ./src/store/modules/city.js